import { useTranslation } from "react-i18next";
import { Skeleton } from "@/components/ui/skeleton.js";

/** Full-page skeleton shown while a lazily loaded route chunk is downloading. */
export function PageLoadingFallback(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-[50vh] flex-col gap-4 p-6">
      <Skeleton className="h-8 w-64" />
      <Skeleton className="h-40 w-full rounded-xl" />
      <Skeleton className="h-32 w-full rounded-xl" />
      <p className="sr-only">{t("common.loading")}</p>
    </div>
  );
}
